import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Quadro from "../suporte/pages/Quadro";
import Historico from "../suporte/pages/Historico";
import Relatorios from "../suporte/pages/Relatorios";
import { PaginaFormularios } from "../suporte/Formularios";
import { BaseClientes } from "../suporte/pages/Bases";
import { Importar, Listas, ConsultaProtocolo } from "../suporte/pages/Admin";
import CardsFila from "../suporte/pages/CardsFila";
import CardsDaFila from "../suporte/pages/CardsDaFila";
import FormulariosValidar from "../suporte/pages/FormulariosValidar";
import Manuais from "../suporte/pages/Manuais";
import Metas from "../suporte/pages/Metas";
import Painel from "../suporte/pages/Painel";
import ControleDocumentos from "../suporte/pages/ControleDocumentos";
import StatusAreas from "../suporte/pages/StatusAreas";
import Feedback from "../suporte/pages/Feedback";
import Grupos from "../suporte/pages/Grupos";
import Supervisao from "../suporte/pages/Supervisao";
import Documentacao from "../suporte/pages/Documentacao";
import Satisfacao from "../suporte/pages/Satisfacao";
import Areas from "../suporte/pages/Areas";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Painel} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
                <Route exact path="/suporte/quadro" component={Quadro} isPrivate />
                <Route exact path="/suporte/validar" component={FormulariosValidar} isPrivate />
                <Route exact path="/suporte/manuais" component={Manuais} isPrivate />
                <Route exact path="/suporte/metas" component={Metas} isPrivate />
                <Route exact path="/suporte/historico" component={Historico} isPrivate />
                <Route exact path="/suporte/protocolo" component={ConsultaProtocolo} isPrivate />
                <Route exact path="/suporte/clientes" component={BaseClientes} isPrivate />
                <Route exact path="/suporte/importar" component={Importar} isPrivate />
                <Route exact path="/suporte/listas" component={Listas} isPrivate />
                <Route exact path="/suporte/cards" component={CardsFila} isPrivate />
                <Route exact path="/suporte/cards-fila" component={CardsDaFila} isPrivate />
                <Route exact path="/suporte/documentos" component={ControleDocumentos} isPrivate />
                <Route exact path="/suporte/relatorios" component={Relatorios} isPrivate />
                <Route exact path="/suporte/formularios" component={PaginaFormularios} isPrivate />
                <Route exact path="/suporte/status-areas" component={StatusAreas} isPrivate />
                <Route exact path="/suporte/feedback" component={Feedback} isPrivate />
                <Route exact path="/suporte/grupos" component={Grupos} isPrivate />
                <Route exact path="/suporte/supervisao" component={Supervisao} isPrivate />
                <Route exact path="/suporte/documentacao" component={Documentacao} isPrivate />
                <Route exact path="/suporte/satisfacao" component={Satisfacao} isPrivate />
                <Route exact path="/suporte/areas" component={Areas} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
